/**
 * Sina (application_id 83) のテーマカラー。未登録 appId 時のフォールバックも兼ねる。
 * Tailwind の `cyan` / `teal` 既定値そのまま = テーマ切り替え前の見た目。
 */
import { tailwindScales as tw } from "../tailwindColors";
import type { ThemePalette } from "../types";

export const SINA_PALETTE: ThemePalette = {
  appId: "83",
  appName: "Sina",
  cyan: tw.cyan,
  teal: tw.teal,
  gradient: { from: tw.cyan[500], to: tw.teal[400] },
  ink: { base: "#18181b", soft: "#3f3f46", mute: "#71717a" },
  app: { bg: "#ffffff", card: "#ffffff" },
};
